import { render, staticRenderFns } from "./TextComponent.vue?vue&type=template&id=331d83ff"
import script from "./TextComponent.vue?vue&type=script&lang=js"
export * from "./TextComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports